import React from 'react'
import _ from 'lodash'

import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

export default function DisplayImageUploadAttribute({
  stationData,
  attributeData,
  diagramData,
  display,
}) {
  // let type = diagramData?.diagramTypeImage
  // console.log('attribule', diagramData, attributeData)
  return (
    <img
      src={diagramData.diagramImage}
      alt={diagramData.diagramName}
      className="w-full h-full"
    />
  )
}
